import React from "react";
import { useTranslation } from "react-i18next";
import "./Buzzing.css";

const Buzzing = () => {
  const { t } = useTranslation();

  return (
    <div className="md:!px-42">
      <div className="buzzing">
        <div className="left-content-buzzing">
          <h3>{t("foodarna.overview.title")}</h3>
        </div>
        <div className="right-content-buzzing">
          <h4>{t("foodarna.overview.heading")}</h4>
          <p>{t("foodarna.overview.description")}</p>
        </div>
      </div>
      <div
        className="buzzing visionFoodrna
"
      >
        <div className="left-content-buzzing">
          <h3>{t("foodarna.vision.title")}</h3>
        </div>
        <div className="right-content-buzzing">
          <h4>{t("foodarna.vision.heading")}</h4>
          <p>{t("foodarna.vision.description")}</p>
        </div>
      </div>
    </div>
  );
};

export default Buzzing;
